import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'banner-swiper',
  name: '轮播 Banner',
  icon: '播',
  group: '微短剧组件',
  description: '首页运营轮播，展示剧本、场地和活动入口',
  defaultProps: {
    title: '微短剧产业服务平台',
    interval: 4000,
    height: 360
}
}
